/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import { cashDiscountHead } from "../../../../../config/constant";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import { NavLink } from "react-router-dom";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import clsx from "clsx";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const CashDiscountTable = (props) => {
    const { onRequestSort, sortOrder, sortBy, details, onEdit, loadTasks, loadMore, loadMoreContent, loadMoreTask, roleManagement, moduleType } = props;

    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteData, setDeleteData] = useState({});

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setDeleteData({
            id: data.id,
            code: data.code
        })
    };

    const classes = customStyles()

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={cashDiscountHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(cashDiscountHead, 0) }}><span style={{ width: getColumnWidth(cashDiscountHead, 0) }}>{data.code}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(cashDiscountHead, 1) }}><span style={{ width: getColumnWidth(cashDiscountHead, 1) }} className={classes.descEllipsis}>{data.description ? data.description : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(cashDiscountHead, 2) }}><span style={{ width: getColumnWidth(cashDiscountHead, 2) }}>{`${data.percentage}%`}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Cash Discount', 'edit', moduleType ? moduleType : 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Cash Discount', 'deletable', moduleType ? moduleType : 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Cash Discount'}</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }

                    </>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={deleteData?.id} loadTasks={() => loadTasks()} name={deleteData?.code} url={'taxcode'} title={'Tax Code'} visible={deleteModal} />
        </>
    )
}